import { render } from "./HeroiconsOutlineUserCircle.vue?vue&type=template&id=2735f653"
const script = {}

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineUserCircle.vue"]])

export default __exports__